// @ts-ignore
import cryptoJs from "crypto-js";
import CallApp from "callapp-lib";

let newPrice = {},
    takeSymbol = '',
    ws: WebSocket | null = null,
    wsInterval = null,     // websocket订阅包定时器
    storageData = {};             // websocket


export default {
    // @ts-ignore
    install(Vue) {

        Vue.prototype.$genQuery = function (data: any) {
            // @ts-ignore
            let query = {
                member_uuid: localStorage.getItem('member_uuid') || '',
                api_token: localStorage.getItem('api_token') || '',
                source: 1,
                version: '1.0',
                third_tag: 1,
                app_market: '',
                // @ts-ignore
                time: Date.parse(new Date()) / 1000,
                lat: '',
                lon: '',
                // @ts-ignore
                device_sn: Date.parse(new Date()) / 1000
            }
            if (data) {
                for (const it in data) {
                    // @ts-ignore
                    if (!query[it]) {
                        // @ts-ignore
                        query[it] = data[it]
                    } else {
                        // @ts-ignore
                        query[it] = data[it]
                    }
                }
            }
            return query

        },
            Vue.prototype.$encrypt = function (qdata: any) {
                let str = ''
                for (const it in qdata) {
                    if (!str) {
                        str += it + '=' + qdata[it]
                    } else {
                        str += '&' + it + '=' + qdata[it]
                    }
                }
                let key = cryptoJs.enc.Latin1.parse('df28a957671eab5436e6beeba2515b28'); //为了避免补位，直接用16位的秘钥
                let iv = cryptoJs.enc.Latin1.parse('1172130435061718'); //16位初始向量
                let encrypted = cryptoJs.AES.encrypt(encodeURIComponent(str), key, {
                    iv,
                    mode: cryptoJs.mode.CBC,
                    padding: cryptoJs.pad.Pkcs7
                });
                return encodeURIComponent(encrypted.toString());
            },
            // @ts-ignore
            Vue.prototype.$accAdd = function (arg1, arg2) {
                let r1, r2, m, n;
                try {
                    r1 = arg1.toString().split(".")[1].length;
                } catch (e) {
                    r1 = 0;
                }
                try {
                    r2 = arg2.toString().split(".")[1].length;
                } catch (e) {
                    r2 = 0;
                }
                m = Math.pow(10, Math.max(r1, r2));
                n = (r1 >= r2) ? r1 : r2;
                return ((arg1 * m + arg2 * m) / m).toFixed(n);
            },
            // @ts-ignore
            Vue.prototype.$accSub = function (arg1, arg2) {
                let r1, r2, m, n;
                try {
                    r1 = arg1.toString().split(".")[1].length;
                } catch (e) {
                    r1 = 0;
                }
                try {
                    r2 = arg2.toString().split(".")[1].length;
                } catch (e) {
                    r2 = 0;
                }
                m = Math.pow(10, Math.max(r1, r2));
                n = (r1 >= r2) ? r1 : r2;
                return ((arg1 * m - arg2 * m) / m).toFixed(n);
            },


            // 量子长链接
            // @ts-ignore
            Vue.prototype.connectWs = function (subscribeArr) {
                if (typeof (WebSocket) == undefined) return
                if (ws == null || ws.readyState != 1) {
                    let profitOld = "--", rateProfitOld = "--";
                    ws = new WebSocket(this.$store.state.wsUrl)
                    // ws链接成功    传参
                    ws.onopen = (ddd) => {
                        // @ts-ignore
                        ws.send(wsLoginBag(this.$md5, subscribeArr));
                        wsInterval = setInterval(() => {
                            // @ts-ignore
                            ws.send(JSON.stringify({command: 3}))
                        }, 500)
                    }
                    if (localStorage.newPriceKey) {
                        newPrice = JSON.parse(localStorage.newPriceKey)
                    }
                    // 接受数据处理
                    ws.onmessage = (e) => {
                        let data = JSON.parse(e.data);
                        let body = data.body
                        if (data.command == 11) { //登录成功
                            // @ts-ignore
                            ws.send(wsChangeDestine(subscribeArr));
                            return
                        }
                        if (data.command == 12) {  //历史缓存
                            if (body && body.length > 0) {
                                // @ts-ignore
                                body.forEach(item => {
                                    profitOld = (item.strike - item.yesterdayClose).toFixed(item.digits || 2);     //  涨跌幅
                                    rateProfitOld = ((item.strike - item.yesterdayClose) / item.yesterdayClose * 100).toFixed(2);    // 涨跌幅率
                                    if (isNaN(parseFloat(profitOld))) {
                                        profitOld = "--"
                                    }
                                    if (isNaN(parseFloat(rateProfitOld))) {
                                        rateProfitOld = "--"
                                    }
                                    // @ts-ignore
                                    newPrice[item.symbol] = {
                                        ask: item.ask,
                                        bid: item.bid,
                                        digits: item.digits,
                                        symbol: item.symbol,
                                        tm: item.tm,
                                        workingTime: item.workingTime,
                                        yesterdayClose: item.yesterdayClose,
                                        profit: profitOld,
                                        rateProfit: rateProfitOld,
                                        strike: item.strike,
                                        highPrice: item.highPrice || '--',
                                        lowPrice: item.lowPrice || '--',
                                        openPrice: item.openPrice || '--',
                                    }
                                    this.resetSetItem("newPriceKey", JSON.stringify(newPrice))
                                })
                            }
                        }
                        // command   14: 最新推送
                        if (data.command == 14) {
                            if (body.code == 0) return false;
                            // @ts-ignore
                            let sd = newPrice[body.symbol];
                            if (!sd) return;
                            if (sd.yesterdayClose != 0) {
                                profitOld = (body.strike - sd.yesterdayClose).toFixed(sd.digits || 2);     //  涨跌幅
                                rateProfitOld = ((body.strike - sd.yesterdayClose) / sd.yesterdayClose * 100).toFixed(2);    // 涨跌幅率
                                if (isNaN(parseFloat(profitOld))) {
                                    profitOld = "--"
                                }
                                if (isNaN(parseFloat(rateProfitOld))) {
                                    rateProfitOld = "--"
                                }
                            }
                            // @ts-ignore
                            newPrice[body.symbol].ask = body.ask
                            // @ts-ignore
                            newPrice[body.symbol].bid = body.bid
                            // @ts-ignore
                            newPrice[body.symbol].strike = body.strike
                            // @ts-ignore
                            newPrice[body.symbol].tm = body.tm
                            // @ts-ignore
                            newPrice[body.symbol].profit = profitOld
                            // @ts-ignore
                            newPrice[body.symbol].rateProfit = rateProfitOld
                            this.resetSetItem("newPriceKey", JSON.stringify(newPrice))
                        }
                    }
                    // ws报错
                    ws.onerror = (err) => {
                        clearInterval(this.wsInterval)
                    }
                    // ws关闭
                    ws.onclose = (err) => {
                        clearInterval(this.wsInterval)
                    }
                } else {   // 已经有连接ws
                    ws.send(wsChangeDestine(subscribeArr));
                }
            },

            // 监听storage更改
            // @ts-ignore
            Vue.prototype.resetSetItem = function (key, newVal) {
                if (key === "btmBanner") {        // 最新报价更新
                    let newStorageEvent = document.createEvent('StorageEvent');
                    const storage = {
                        // @ts-ignore
                        setItem: function (k, val) {
                            localStorage.setItem(k, val);
                            // 初始化创建的事件
                            // @ts-ignore
                            newStorageEvent.initStorageEvent('btmBanner', false, false, k, null, val, null, null);
                            // 派发对象
                            window.dispatchEvent(newStorageEvent)
                        }
                    }
                    return storage.setItem(key, newVal);
                }
                if (key === "href") {        // 最新报价更新
                    let newStorageEvent = document.createEvent('StorageEvent');
                    const storage = {
                        // @ts-ignore
                        setItem: function (k, val) {
                            localStorage.setItem(k, val);
                            // 初始化创建的事件
                            // @ts-ignore
                            newStorageEvent.initStorageEvent('href', false, false, k, null, val, null, null);
                            // 派发对象
                            window.dispatchEvent(newStorageEvent)
                        }
                    }
                    return storage.setItem(key, newVal);
                }
                if (key === "newPriceKey") {        // 最新报价更新
                    let newStorageEvent = document.createEvent('StorageEvent');
                    const storage = {
                        // @ts-ignore
                        setItem: function (k, val) {
                            localStorage.setItem(k, val);
                            // 初始化创建的事件
                            // @ts-ignore
                            newStorageEvent.initStorageEvent('newPrice', false, false, k, null, val, null, null);
                            // 派发对象
                            window.dispatchEvent(newStorageEvent)
                        }
                    }
                    return storage.setItem(key, newVal);
                }
                if (key === "allSymDataKey") {        // 最新报价更新
                    let newStorageEvent = document.createEvent('StorageEvent');
                    const storage = {
                        // @ts-ignore
                        setItem: function (k, val) {
                            localStorage.setItem(k, val);
                            // 初始化创建的事件
                            // @ts-ignore
                            newStorageEvent.initStorageEvent('allSymData', false, false, k, null, val, null, null);
                            // 派发对象
                            window.dispatchEvent(newStorageEvent)
                        }
                    }
                    return storage.setItem(key, newVal);
                }
            },
            // 点差计算
            // @ts-ignore
            Vue.prototype.countDot = function (ask, bid, digit) {
                if (digit == 0) digit = 1;
                if (ask == 0 && bid == 0) return "0.0"
                let dot = ask - bid
                // @ts-ignore
                dot = (dot * Math.pow(10, (digit - 1))).toFixed(1)
                return dot
            },


            Vue.prototype.$getTime = function (nS: any) {
                let date = new Date(parseInt(nS));
                let year = date.getFullYear();
                let mon = date.getMonth() + 1;
                let day = date.getDate();
                let hours = date.getHours();
                let minu = date.getMinutes();
                let sec = date.getSeconds();

                return year + '/' + mon + '/' + day + ' ' + hours + ':' + minu + ':' + sec;

            },
            Vue.prototype.$getWeek = function (days: any, type: any) {
                //type : 0 默认 : !0 简式
                switch (days) {
                    case 1:
                        days = type === 0 ? '星期一' : '一';
                        break;
                    case 2:
                        days = type === 0 ? '星期二' : '二';
                        break;
                    case 3:
                        days = type === 0 ? '星期三' : '三';
                        break;
                    case 4:
                        days = type === 0 ? '星期四' : '四';
                        break;
                    case 5:
                        days = type === 0 ? '星期五' : '五';
                        break;
                    case 6:
                        days = type === 0 ? '星期六' : '六';
                        break;
                    case 0:
                        days = type === 0 ? '星期日' : '日';
                        break;
                }
                return days
            }


        Vue.prototype.$summary = function (text: any) {
            let len = 0;
            let max = 30;
            let val = 0;
            let ellipsis = true;
            for (let i = 0; val <= max; i++) {
                if (isNaN(text.charCodeAt(i))) {
                    ellipsis = false;
                    break;
                }
                val += text.charCodeAt(i) > 255 ? 2 : 1;
                len += 1;
            }
            return ellipsis ? text.slice(0, len) + "..." : text.slice(0, len);
        }

        Vue.prototype.$dateChange = function (createdDate: any) {
            let lastDate = this.$parseISO(createdDate)
            let dateNow = new Date()
            // @ts-ignore
            let time = (dateNow - lastDate) / 1000
            let show = ""
            if (time >= 31556736) {
                show = this.$math.floor(time / 31556736) + '年前'
            } else if (time >= 2629743) {
                show = (this.$math.floor(time / 2629743) >= 12 ? '1年前' : this.$math.floor(time / 2629743) + '月前')
            } else if (time >= 604800) {
                show = (this.$math.floor(time / 604800) >= 4 ? '1月前' : this.$math.floor(time / 604800) + '周前')
            } else if (time >= 86400) {
                show = this.$math.floor(time / 86400) + '天前'
            } else if (time >= 3600) {
                show = this.$math.floor(time / 3600) + '小时前'
            } else if (time >= 60) {
                show = this.$math.floor(time / 60) + '分钟前'
            } else {
                show = '刚刚'
            }
            return show
        }
        Vue.prototype.$stDateChange = function (value: any) {
            let stDate = this.$format(this.$parseISO(value), "MM-dd")
            let stTime = this.$format(this.$parseISO(value), "HH:mm")
            return stDate + " " + stTime;
        }
        Vue.prototype.$getFreshPrice = function () {
            if (localStorage.newPriceKey) {
                this.priceData = JSON.parse(localStorage.newPriceKey)
                if (this.$store.state.getFreshPrice) {
                    this.$forceUpdate()
                }

            }
        }
        Vue.prototype.$infoDetailJump = function (id: any) {
            if (this.$route.fullPath !== '/informationDetail') {
                this.$router.push({path: '/informationDetail', query: {id}})
            }
        }
        Vue.prototype.$stDetailJump = function (id: any) {
            if (this.$route.path !== '/strategyDetail') {
                this.$router.push('/strategyDetail')
                this.$router.push({path: '/strategyDetail', query: {id}})
            }
        }

        // @ts-ignore
        Vue.prototype.$dateCheckNF = function (myDate, lastData) {
            if (lastData === '') {
                return true
            } else {
                return this.$format(this.$parseISO(myDate), "MM-dd") !== this.$format(this.$parseISO(lastData), "MM-dd")
            }

        }
        // @ts-ignore
        Vue.prototype.$dateMDNF = function (date) {
            return {
                month: this.$format(this.$parseISO(date), "M"),
                day: this.$format(this.$parseISO(date), "dd")
            }
        }
        // @ts-ignore
        Vue.prototype.$dateChangeNF = function (value) {
            return this.$format(this.$parseISO(value), "HH:mm:ss")
        }
        // @ts-ignore
        Vue.prototype.$setUserData = function (item) {
            localStorage.setItem('member_uuid', item.data.member_uuid)
            localStorage.setItem('api_token', item.data.api_token)
            localStorage.setItem('mobile', item.data.mobile)
            localStorage.setItem('nickName', item.data.nick_name)
            localStorage.setItem('headImg', item.data.head_img)
            localStorage.setItem('province_id', item.data.province_id)
            localStorage.setItem('city_id', item.data.city_id)
            localStorage.setItem('province', item.data.province_title)
            localStorage.setItem('city', item.data.city_title)
            localStorage.setItem('sex', item.data.sex)
        }
        // @ts-ignore
        Vue.prototype.$goChart = function (symbol) {
            this.$router.push({path: '/chart', query: {symbol}})

        }
        // @ts-ignore
        Vue.prototype.$kLineType = function (resolution) {
            let type = null
            switch (resolution) {
                case '1':
                    type = 1;
                    break;
                case '15':
                    type = 15;
                    break;
                case '30':
                    type = 60;
                    break;
                case '60':
                    type = 60;
                    break;
                case '240':
                    type = 240;
                    break;
                case '1D':
                    type = 1440;
                    break;
                case '1W':
                    type = 10080;
                    break;
                case '1M':
                    type = 43200;
                    break;
            }
            return type
        }

        Vue.prototype.$back = function (this) {
            const that = this
            that.$router.go(-1)
        }
        Vue.prototype.$backHome = function (this) {
            const that = this
            that.$router.push('/')
        }


        Vue.prototype.$openApp = function () {

            // 是微信内部webView
            // if (this.is_weixn()) {
            //     alert("请点击右上角按钮, 点击使用浏览器打开");
            // }else {
            const options = {
                scheme: {protocol: "tubiaojia://m.tubiaojia.com/"}, //要打开的 APP 的标识
                intent: {
                    package: "",  //包名
                    scheme: "tubiaojia://"
                },

                timeout: 6000,
                //apple store
                appstore: "https://apps.apple.com/cn/app/id1448090757",
                //应用宝
                // yinyongbao:"",
                fallback: "https://img.tubiaojia.cn/app_package/tubiaojia-own-market-v9.0.0.apk" //唤端失败后跳转的地址
            };
            const callLib = new CallApp(options);
            // @ts-ignore
            callLib.open({});
            // }

        }


        Vue.prototype.$bell = function (this) {
            const that = this
            that.$dialog.confirm({
                title: '提示',
                message: '是否打开App设置提醒',
                confirmButtonColor:'#1875f8',
                cancelButtonColor:'#919bad',
                closeOnClickOverlay:true
            })
                .then(() => {
                    // on confirm
                    this.$openApp()
                })
                .catch(() => {
                    // on cancel
                });


        }

        Vue.prototype.$callPhone = function (this) {
            const that = this
            that.$dialog.confirm({
                title: '提示',
                message: '是否打开App联系客服',
                confirmButtonColor:'#1875f8',
                // confirmButtonText:'拨打',
                cancelButtonColor:'#919bad',
                closeOnClickOverlay:true
            })
                .then(() => {
                    // on confirm
                    // window.location.href = 'tel://'
                    this.$openApp()
                })
                .catch(() => {
                    // on cancel
                });


        }

    }


}

// 长链接登录包
// @ts-ignore
function wsLoginBag(md5, subscribeArr) {
    // @ts-ignore
    let loginTime = parseInt(new Date() / 1000);
    let devId = "web";
    let nonceStr = "aaaaaaaa";
    let clientInfo = "wap_h5";
    let sign = md5(loginTime + "," + devId + "," + nonceStr + ",edeb89b0b1653370523aa8072bcaeeb2")
    let body = {
        loginTime: loginTime,
        devId: devId,
        sign: sign,
        nonceStr: nonceStr,
        clientInfo: clientInfo,
        symbols: subscribeArr || [],            // 登录包默认不订阅品种   进入对应页面会调用订阅包修改订阅品种
    }
    let heart = JSON.stringify({command: 1, body: body});
    return heart
}

// 长链接订阅包   *** 修改订阅品种
// @ts-ignore
function wsChangeDestine(subscribeArr) {
    let heart = JSON.stringify({command: 2, body: subscribeArr || []});
    return heart
}
